<template>
	<div class="drawer-links">
		<div class="title-container">
			<div class="title">Manage Tags</div>
			<div class="buttons">
				<a href @click.prevent="close" class="button"><div class="hover-title">Close</div><span class="fa fa-times"></span></a>
			</div>
		</div>
		<router-link v-for="tag in tags.fields" :key="tag.id" :to="tag.type === 'tags' ? `/module/${module.slug}/tags/${tag.id}` : `${ module.url_path_prefix }${ tag.specific_data }`" @click="close" class="link">
			{{ tag.name }}<span class="count">{{ tags.numTags[ tag.id ] || 0 }}</span>
		</router-link>
	</div>
</template>

<script>

import { DRAWERS } from '@/constants';

export default {

	props: [ 'tags', 'module' ],

	methods: {

		isActive(tag) {
			return tag.id === this.$route.params.id && this.$route.name === 'tags';
		},

		close() {
			this.$root.$emit('close-drawer', DRAWERS.MANAGE_TAGS);
		},

	},
};

</script>
